import React from "react";

const LeftImage = ({ data }) => {
  return (
    <>
      <section className=" ">
        <div className=" ">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Image */}
            <div>
              <img
                src={data[0]?.image}
                alt="Car"
                className="w-full h-full object-cover rounded-r-xl "
              />
            </div>

            {/* Right Content */}
            <div className="w-full   px-5 md:pe-20">
              <h2 className="text-[20px] md:text-[30px]  font-semibold my-4 leading-[56px]">
                {data[0]?.title?.split(" ").map((word, i) =>
                  word.toLowerCase() === "fair" ||
                  word.toLowerCase() === "today" ? (
                    <span key={i} className="text-primary-dark">
                      {word}{" "}
                    </span>
                  ) : (
                    word + " "
                  )
                )}
              </h2>

              <p className="text-gray-600 mb-6 leading-relaxed ">
                <div
                  className="text-gray-600 mb-6 leading-relaxed "
                  dangerouslySetInnerHTML={{
                    __html: data[0]?.description,
                  }}
                />
                {/* {data[0]?.description} */}
              </p>

              <ul className="space-y-4 mb-8 text-gray-800 text-sm">
                {[
                  // "We are the UAE's largest provider, with more referrals in more places",
                  // "You get 24/7 roadside assistance",
                  // "We fix 4 out of 5 cars at the roadside",
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <div className="min-w-[24px] min-h-[24px] mr-3 flex items-center justify-center bg-primary-dark rounded-full">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9"
                        height="7"
                        viewBox="0 0 9 7"
                        fill="none"
                      >
                        <path
                          d="M3.37813 6.42383L0.784375 3.83008C0.628125 3.67383 0.628125 3.4082 0.784375 3.25195L1.34688 2.68945C1.50313 2.5332 1.75313 2.5332 1.90938 2.68945L3.675 4.43945L7.425 0.689453C7.58125 0.533203 7.83125 0.533203 7.9875 0.689453L8.55 1.25195C8.70625 1.4082 8.70625 1.67383 8.55 1.83008L3.95625 6.42383C3.8 6.58008 3.53438 6.58008 3.37813 6.42383Z"
                          fill="#fff"
                        />
                      </svg>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>

              <button
                className="w-[184px] flex items-center gap-3 justify-center text-[16px] h-[44px] rounded-xl font-500 bg-primary-dark text-[#FFEFEF]"
                onClick={() =>
                  (window.location.href = data[0]?.buttonLink || "#")
                }
              >
                {data[0]?.buttonText}{" "}
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M13.6111 0H5.05557C4.84061 0 4.66667 0.173943 4.66667 0.388901C4.66667 0.603859 4.84061 0.777802 5.05557 0.777802H12.6723L0.113941 13.3362C-0.0379804 13.4881 -0.0379804 13.7342 0.113941 13.8861C0.189884 13.962 0.289415 14 0.38891 14C0.488405 14 0.5879 13.962 0.663879 13.8861L13.2222 1.3277V8.94447C13.2222 9.15943 13.3961 9.33337 13.6111 9.33337C13.8261 9.33337 14 9.15943 14 8.94447V0.388901C14 0.173943 13.826 0 13.6111 0Z"
                      fill="#FFEFEF"
                    />
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LeftImage;
